import React, { useEffect, useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';

import './App.css';

import logoWhite from './logo-white.png';

let db

function App() {
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    firebase.initializeApp({
      apiKey: "AIzaSyBICpxwcw1mJC8so2uLjVCGeSjRS7ctYg8",
      authDomain: "genally-5dfe8.firebaseapp.com",
      projectId: "genally-5dfe8",
    })
    db = firebase.firestore()
  }, [])

  const [firstname, setFirstname] = useState('')
  const [lastname, setLastname] = useState('')
  const [email, setEmail] = useState('')

  const save = async () => {
    if (!db || !firstname || !email) {
      alert('กรุณากรอกข้อมูลให้ครบถ้วน ขอบคุณค่ะ')
      return
    }

    try {
      setLoading(true)
      await db.collection('users').add({
        firstname,
        lastname,
        email,
      })

      setFirstname('')
      setLastname('')
      setEmail('')
      alert('ลงทะเบียนเสร็จสิ้น ขอบคุณค่ะ')
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='container'>
      <div className='text-center'>
        <img
          src={logoWhite}
          alt='Genally Logo'
          className='logo'
        />
      </div>
      <div className='box'>
        <form>
          <div className='form-row'>
            <div className="form-group col-md-6">
              <label htmlFor="firstname-input">
                ชื่อจริง
              </label>
              <input
                type="text"
                className="form-control"
                id="firstname-input"
                placeholder="กรอกชื่อจริง.."
                value={firstname}
                onChange={e => setFirstname(e.target.value)}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="lastname-input">
                นามสกุล
              </label>
              <input
                type="text"
                className="form-control"
                id="lastname-input"
                placeholder="กรอกนามสกุล.."
                value={lastname}
                onChange={e => setLastname(e.target.value)}
              />
            </div>
          </div>
          
          <div className='form-row'>
            <div className="form-group col-12">
              <label htmlFor="email-input">
                อีเมล
              </label>
              <input
                type="email"
                className="form-control"
                id="email-input"
                placeholder="กรอกอีเมล.."
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
          </div>
        </form>

        <div className='text-center'>
          <button
            type='button'
            className="btn btn-primary btn-lg"
            onClick={save}
            disabled={isLoading}
          >
            {isLoading
              ? 'กำลังลงทะเบียน...'
              : 'ลงทะเบียน'
            }
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
